export const COMPANY_PAGES = {
  searchPage: {
    label: 'Search Professionals',
    icon: 'user'
  },
  offersPage: {
    label: 'Shift Offers',
    icon: 'appstore'
  },
  profilePage: {
    label: 'Profile',
    icon: 'idcard'
  },
  securityPage: {
    label: 'Change Password',
    icon: 'lock'
  },
  contactPage: {
    label: 'Contact Us',
    icon: 'mail'
  }  
}

export const PROFESSIONAL_PAGES = {
  timesheetsPage: {
    label: 'Timesheets',
    icon: 'project'
  },
  offersPage: {
    label: 'Shift Offers',
    icon: 'appstore'
  },
  profilePage: {
    label: 'Profile',
    icon: 'idcard'
  },
  securityPage: {
    label: 'Security & Login',
    icon: 'lock'
  },
  contactPage: {
    label: 'Contact Us',
    icon: 'mail'
  }
}

export const FOOTER_TEXT = {
  label: 'NMC Registered ©2021 Created by',
  author: 'Salman Haider',
  profileLink: 'https://www.linkedin.com/in/salman-hayder/'
}